import React from "react";

export default function PlusIconSvg(Props) {
  // console.log("Props in PlusIconSvg: ", Props);
  return Props.type === 4 ? (
   <svg
           width="20"
           height="20"
           viewBox="0 0 20 20"
           fill="none"
           xmlns="http://www.w3.org/2000/svg"
         >
           <path
             d="M10.0001 4.16666V15.8333M4.16675 10H15.8334"
             stroke={Props.stroke ? Props.stroke : "#344054"}
             strokeWidth="1.67"
             strokeLinecap="round"
             strokeLinejoin="round"
           />
    </svg>
  ): Props.type === 3 ? (
    <svg
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="15" height="15" rx="5.5" stroke="#98A2B3" />
      <path
        stroke="#98A2B3"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.00016 5.0835V10.9168M5.0835 8.00016H10.9168"
      />
    </svg>
  ) : Props.type === 2 ? (
    <svg
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke="#344054"
        stroke-width="2"
        d="M8 1V15M1 8H15"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ) : (
    <svg
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40"
      onClick={Props.onClick}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_453_4572)">
        <rect x="2" y="1" width="36" height="36" rx="8" fill="white" />
        <rect
          x="2.5"
          y="1.5"
          rx="7.5"
          width="35"
          height="35"
          stroke="#D0D5DD"
        />
        <path
          stroke="#344054"
          stroke-width="1.67"
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M20 13.167V24.8337M14.1666 19.0003H25.8333"
        />
      </g>
      <defs>
        <filter
          x="0"
          y="0"
          width="40"
          height="40"
          id="filter0_d_453_4572"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_453_4572"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect1_dropShadow_453_4572"
          />
        </filter>
      </defs>
    </svg>
  );
}
